import { useMemo } from "react";

import { Product } from "@transfr-inc/dashboard-components/constants";

import { ClassroomCeMenuBuilder } from "@views/classrooms/details/components/menu-builder/layout/ce-menu-builder";
import { ClassroomTsMenuBuilder } from "@views/classrooms/details/components/menu-builder/layout/ts-menu-builder";
import { ProductTab } from "@views/shared/product-tab/product.tab";

import "./classroom.menu-builder.tab.scss";

export const ClassroomMenuBuilderTab = ({
  name,
  className,
  classroom,
  readOnly,
}) => {
  const menuBuilderTabs = useMemo(() => {
    const tabs = {
      [Product.TS]: (
        <ClassroomTsMenuBuilder classroom={classroom} readOnly={readOnly} />
      ),
      [Product.CE]: (
        <ClassroomCeMenuBuilder classroom={classroom} readOnly={readOnly} />
      ),
    };
    return classroom?.products?.reduce((acc, product) => {
      if (tabs[product]) {
        acc[product] = tabs[product];
      }
      return acc;
    }, {});
  }, [classroom, readOnly]);

  return (
    <ProductTab
      name={name}
      className={className}
      productComponents={menuBuilderTabs}
    />
  );
};
